import React from 'react';
import './Tienda.css';
import { GiPill } from 'react-icons/gi';
import { LuBookOpen, LuGraduationCap } from 'react-icons/lu';

const CARDS = [
  {
    icon: <GiPill />,
    title: 'Suplementos',
    desc: 'Fórmulas seleccionadas para objetivos específicos de salud.',
  },
  {
    icon: <LuBookOpen />,
    title: 'Guías prácticas',
    desc: 'Herramientas para organizar tu alimentación con claridad.',
  },
  {
    icon: <LuGraduationCap />,
    title: 'Cursos online',
    desc: 'Aprendé a comer mejor con acompañamiento profesional.',
  },
];

const Tienda = () => (
  <section className="tienda-section">
    <div className="tienda-inner">
      <p className="tienda-label">Tienda online</p>
      <h2 className="tienda-title">Productos y recursos para tu salud</h2>
      <p className="tienda-sub">
        Accedé a suplementos seleccionados, cursos y guías prácticas directamente desde la tienda.
      </p>
      <div className="tienda-cards">
        {CARDS.map((c) => (
          <div key={c.title} className="tienda-card">
            <div className="tienda-icon" aria-hidden="true">{c.icon}</div>
            <h4>{c.title}</h4>
            <p>{c.desc}</p>
            <span className="tienda-badge">Próximamente</span>
          </div>
        ))}
      </div>
      <a
        href="https://tienda.bianangelucci.com.ar/"
        className="tienda-cta"
        target="_blank"
        rel="noreferrer"
      >
        Ir a la tienda online 
      </a>
    </div>
  </section>
);

export default Tienda;
